// extracted by mini-css-extract-plugin
export default {"base":"FdFy1","table":"xsxZx","tableSecondary":"of8J6","solutionColumn":"L71eo","editColumn":"QT_cG","collectionColumn":"YNGRH","filterBar":"edxQl","search":"Tnxcd","filter":"Hurw4"};